import CommonService from '../../../../services/commonService';
import React from 'react';
import { connect } from 'react-redux';
// const bahiaazulServiceIcon4 = './../assets/expresonorte/general/serviceIcon4.svg';
// const bahiaazulServiceIcon5 = './../assets/expresonorte/general/serviceIcon5.svg';
const jeldresIcon1 = '/assets/jeldres/icons/icon-one.svg';
const jeldresIcon2 = '/assets/jeldres/icons/icon-two.svg';
const jeldresIcon3 = '/assets/jeldres/icons/icon-three.svg';

const teupalIcon1 = '/assets/tepual/icons/camera-about-us.svg';
const teupalIcon2 = '/assets/tepual/icons/urban-about-us.svg';
const teupalIcon3 = '/assets/tepual/icons/location-about-us.svg';

const centraltourIcon1 = '/assets/centraltour/Home/CentralTour-Website-Home-Services-01.svg';
const centraltourIcon2 = '/assets/centraltour/Home/CentralTour-Website-Home-Services-02.svg';
const centraltourIcon3 = '/assets/centraltour/Home/CentralTour-Website-Home-Services-03.svg';

const liquineIcon1 = '/assets/liquine/Home/Liquiñe-Website-Home-Services-01.svg';
const liquineIcon2 = '/assets/liquine/Home/Liquiñe-Website-Home-Services-02.svg';
const liquineIcon3 = '/assets/liquine/Home/Liquiñe-Website-Home-Services-03.svg';

const trrassIcon1 = '/assets/trrass/icons/Home-Services1.svg';
const trrassIcon2 = '/assets/trrass/icons/Home-Services2.svg';
const trrassIcon3 = '/assets/trrass/icons/Home-Services3.svg';

const erbucIcon1 = '/assets/erbuc/Home/Erbuc-Website-Home-Services1.svg';
const erbucIcon2 = '/assets/erbuc/Home/Erbuc-Website-Home-Services2.svg';
const erbucIcon3 = '/assets/erbuc/Home/Erbuc-Website-Home-Services3.svg';

const expresonorteServiceIcon1 = './../assets/expresonorte/general/serviceIcon1.svg';
const expresonorteServiceIcon2 = './../assets/expresonorte/general/serviceIcon2.svg';
const expresonorteServiceIcon3 = './../assets/expresonorte/general/serviceIcon3.svg';
const expresonorteServiceIcon4 = './../assets/expresonorte/general/serviceIcon4.svg';
const expresonorteServiceIcon5 = './../assets/expresonorte/general/serviceIcon5.svg';

const bahiaazulServiceIcon1 = '/assets/bahia/Home/BahiaAzul-Website-Home-Services1.svg';
const bahiaazulServiceIcon2 = '/assets/bahia/Home/BahiaAzul-Website-Home-Services2.svg';
const bahiaazulServiceIcon3 = '/assets/bahia/Home/BahiaAzul-Website-Home-Services3.svg';

const teupalIconsAndTexts = [
	{ image: teupalIcon1, caption: 'Giras de estudio' },
	{ image: teupalIcon2, caption: 'Transporte interurbano' },
	{ image: teupalIcon3, caption: 'Viajes especiales' },
];

const centraltourIconsAndTexts = [
	{ image: centraltourIcon1, caption: 'Giras de estudio' },
	{ image: centraltourIcon2, caption: 'Transporte interurbano' },
	{ image: centraltourIcon3, caption: 'Viajes especiales' },
];
const jeldresIconsAndTexts = [
	{ image: jeldresIcon1, caption: 'Servicio de encomiendas' },
	{ image: jeldresIcon2, caption: 'Modernos  buses' },
	{ image: jeldresIcon3, caption: 'Seguridad y comodidad' },
];
const liquineIconsAndTexts = [
	{ image: liquineIcon1, caption: 'Descuentos adultos mayores' },
	{ image: liquineIcon2, caption: 'Transporte interurbano' },
	{ image: liquineIcon3, caption: 'Viaje seguro para bebés' },
];

const expressonorteIconsAndTexts = [
	{ image: expresonorteServiceIcon1, caption: 'Cargador USB' },
	{ image: expresonorteServiceIcon2, caption: 'Semi cama' },
	{ image: expresonorteServiceIcon3, caption: 'Salón cama' },
	{ image: expresonorteServiceIcon4, caption: 'Snacks' },
	{ image: expresonorteServiceIcon5, caption: 'Entretención' },
];

const bahiaazulIconsAndTexts = [
	{ image: bahiaazulServiceIcon1, caption: 'Viajes al Litoral Central' },
	{ image: bahiaazulServiceIcon2, caption: 'Amplia flota' },
	{ image: bahiaazulServiceIcon3, caption: 'Comodidad garantizada' },
	// { image: expresonorteServiceIcon4, caption: 'Snacks' },
	// { image: expresonorteServiceIcon5, caption: 'Entretención' },
];

const erbucIconsAndTexts = [
	{ image: erbucIcon1, caption: 'Viajes interurbanos' },
	{ image: erbucIcon2, caption: 'Amplia flota' },
	{ image: erbucIcon3, caption: 'Comodidad garantizada' },
];

const trrassIconsAndText = [
	{ image: trrassIcon1, caption: 'Amplia flota' },
	{ image: trrassIcon2, caption: 'Transporte interurbano' },
	{ image: trrassIcon3, caption: 'Comodidad garantizada' },
];

const getIconsAndTexts = operator => {
	const name = operator && operator.operator_name;
	if (name === 'tepual') {
		return teupalIconsAndTexts;
	} else if (name === 'expressonorte') {
		return expressonorteIconsAndTexts;
	} else if (name === 'bahiaazul') {
		return bahiaazulIconsAndTexts;
	} else if (name === 'erbuc') {
		return erbucIconsAndTexts;
	} else if (name === 'trrass') {
		return trrassIconsAndText;
	} else if (name === 'centraltour') {
		return centraltourIconsAndTexts;
	} else if (name === 'liquine') {
		return liquineIconsAndTexts;
	}
	else if (name === 'jeldres') {
		return jeldresIconsAndTexts;
	} else {
		return [];
	}
};

const ThemeFiveIconsSection = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	const renderIconsAndText = (item, key, length) => {
		return (
			<React.Fragment>
				<style>
					.borderRight-about-icons {'{'}
					border-right: 1px solid{' '}
					{operator && operator.color_codes && operator.operator_name === 'liquine'
						? operator.color_codes.primary_color
						: operator.color_codes.secondary_color}
					;{'}'}
				</style>
				<div
					className={
						operator.operator_name === 'expressonorte'
							? key + 1 != length && (key + 1) % 5 != 0
								? 'single-item-container borderRight-about-icons'
								: 'single-item-container'
							: key + 1 != length && (key + 1) % 3 != 0
								? 'single-item-container borderRight-about-icons'
								: 'single-item-container'
					}
					style={
						operator.operator_name === 'expressonorte'
							? { width: length <= 3 ? `${100 / length}%` : '20%' }
							: { width: length <= 3 ? `${100 / length}%` : '33%' }
					}
				>
					<div className="single-item">
						<div>
							<img src={item.image} alt="Giras de estudio" className="about-icon" />
						</div>
						<div className="font10">{item.caption}</div>
					</div>
				</div>
			</React.Fragment>
		);
	};

	return (
		<div className="themes-theme-five-icons-section new-container mt10 ">
			<div className="icons-container">
				{getIconsAndTexts(operator).map((item, key) => {
					return renderIconsAndText(item, key, getIconsAndTexts().length);
				})}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}
export default connect(mapStateToProps, {})(ThemeFiveIconsSection);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/components/ThemeFiveIconsSection.js